import axios from "axios";

const state = {
  feedbacks: []
};

const mutations = {
  SET_FEEDBACKS: (state, feedbacks) => {
    state.feedbacks = feedbacks;
  }
};

const actions = {
  async GET_FEEDBACKS(context, data) {
    await axios
      .get("/feedbacks", {
        params: data
      })
      .then(response => {
        context.commit("SET_FEEDBACKS", response.data);
      })
      .catch(error => {
        console.log(error);
      })
      .finally(() => {});
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
